{
    "ExtraCharacters": "1234567890:¥$€£₩￥",
    "ExtraCharactersBold": "1234567890+/i",
    "StartButton": "START!",
    "RiseOfTheBlobsTitle": "RiSE OF THE BLOBS",
    "FBLogin": "LOGiN",
    "FBLogout": "LOGOUT",
    "GetCoins": "GET COiNS!",
    "Offline": "OFFLiNE",
    "HighScores": "HiGH SCORES",
    "Leaderboard": "LEADERBOARD",
    "NewRecord": "NEW RECORD!",
    "RankUp": "RANK UP!",
    "Retry": "REPLAY!",
    "Stats": "STATS",
    "MoreGames": "MORE GAMES",
    "News": "NEWS",
    "Shoppe": "SHOPPE",
    "Achievements": "ACHiEVEMENTS",
    "CaseyRichardson": "Casey Richardson",
    "CreditsGameDirector": "Game Director",
    "JordanFehr": "Jordan Fehr",
    "CreditsAudio": "Audio",
    "JustinQuan": "Justin Quan",
    "CreditsEngSupport": "Engineering Support",
    "ChrisPruett": "Chris Pruett",
    "CreditsEngineering": "Engineering",
    "JonnyRussell": "Jonny Russell",
    "CreditsTechDesign": "Tech Design",
    "MikeWitt": "Mike Witt",
    "MikeMcCool": "Mike McCool",
    "CreditsArt": "Art",
    "JoshWhelchel": "Josh Whelchel",
    "CreditsMusic": "Music",
    "CreditsTitle": "RiSE OF THE BLOBS",
    "CreditsRobotInvader": "@robotinvader",
    "CreditsSpecialThanks": "SPECIAL THANKS",
    "TomMoss": "Tom Moss",
    "GauravMathur": "Gaurav Mathur",
    "StathisMytilinaios": "Stathis Mytilinaios",
    "HaroldDeArmas": "Harold De Armas",
    "MikeComfoltey": "Mike Comfoltey",
    "EdAnnunziata": "Ed Annunziata",
    "MikeChan": "Mike Chan",
    "TaraLong": "Tara Long",
    "NissaCampbell": "Nissa Campbell",
    "BertrandAmar": "Bertrand Amar",
    "CreditsThanksForPlaying": "THANKS FOR PLAYiNG!",
    "DownloadWUK": "Have you played the award winning Wind-up Knight yet? Download it today!",
    "DownloadGame1": "This game is cool for you to download too!",
    "GetItNow": "GET iT NOW",
    "Credits": "CREDiTS",
    "AreaSelect": "STAGE SELECT",
    "ModeSelect": "MODE SELECT",
    "Next": "NEXT",
    "Results": "RESULTS",
    "New": "NEW",
    "Skull": "SKULL",
    "Timed": "TiMED",
    "Easy": "NORMAL",
    "More": "MORE",
    "Normal": "MATCH",
    "Arctic": "ARCTiC",
    "Desert": "DESERT",
    "Forest": "FOREST",
    "Island": "iSLAND",
    "Swamp": "SWAMP",
    "ComingSoon": "COMiNG SOON",
    "Moon": "MOON",
    "Candy": "CANDY",
    "Tutorial": "TUTORiAL",
    "TutorialIntro": "TUTORiAL iNTRO",
    "LoseProgressDialogAccept": "QUiT GAME",
    "LoseProgressDialogReject": "BACK",
    "LoseProgressDialog": "Hey! You're gonna lose some progress. Are you sure you wanna quit?",
    "NeedMoreCoinsDialogReject": "CANCEL",
    "NeedMoreCoinsDialog": "Aw shucks! You don't have enough coins for this! Do you wanna get more coins now?",
    "NeedMoreCoinsDialog2": "Graham Crackers! Not enough coins. You wanna get more now?",
    "NeedMoreCoinsDialog3": "You don't have enough coins. Wanna get more coins now?",
    "NeedMoreCoinsDialog4": "Not enough coins! Wanna get more?",
    "NeedMoreCoinsDialogAccept": "GET COiNS!",
    "MoreCoinsForPowerupDialogReject": "NO",
    "MoreCoinsForPowerupDialog": "Aw shucks! You need more coins to unlock this power-up! Do you want to get more coins now?",
    "MoreCoinsForPowerupDialogAccept": "YES",
    "NeedToUnlockDialogAccept": "YES",
    "NeedToUnlockDialogReject": "NO",
    "RestartGameDialogAccept": "RESTART",
    "RestartGameDialogReject": "CANCEL",
    "RestartGameDialog": "Wanna restart your game? For serious?! You're gonna lose some progress.",
    "QuitGameDialog": "Are you sure you want to quit this awesome game?",
    "QuitGameDialogAccept": "QUiT",
    "QuitGameDialogReject": "CANCEL",
    "PurchaseCoinsDialog": "You got {0} coins!",
    "PurchaseCoinsDialogAccept": "YEAH!",
    "PurchaseElitePackDialog": "Welcome to the club!",
    "PurchaseElitePackDialogAccept": "AWESOME!",
    "PurchaseUnlockAllDialog": "You got it! Content Unlocked!",
    "PurchaseUnlockAllDialogAccept": "OH YEAH",
    "PurchaseCoinDoublerDialog": "Oh yeah! Double ALL the coins!",
    "PurchaseCoinDoublerDialogAccept": "CHA-CHiNG!",
    "PurchaseFailedDialog": "Uh-oh, looks like there was an error while trying to process your purchase.  The transaction was cancelled.  ({0})",
    "PurchaseFailedDialogAccept": "OKAY",
    "TapjoyEarnedCoinsDialog": "You earned {0} FREE coins!",
    "TapjoyEarnedCoinsDialogAccept": "HOORAY!",
    "SocialEarnedCoinsDialog": "You earned {0} FREE coins!",
    "SocialEarnedCoinsDialogAccept": "HOORAY!",
    "PleaseRateUsDialogMessageIOS": "This game is pretty awesome, right?  Please take a moment to rate us on the App Store!",
    "PleaseRateUsDialogMessageAndroid": "This game is pretty awesome, right? Please take a moment to rate us on Google Play.",
    "PleaseRateUsDialogMessageGeneric": "This game is pretty awesome, right?  Please take a moment to tell us what you think.",
    "PleaseRateUsDialogMessageAccept": "RATE",
    "PleaseRateUsDialogMessageCancel": "LATER",
    "NewVersionAvailableDialog": "A new version of Rise of the Blobs is available!  Download it now!",
    "NewVersionAvailableDialogAccept": "DOWNLOAD",
    "NewVersionAvailableDialogCancel": "LATER",
    "Off": "OFF",
    "On": "ON",
    "MusicFormat": "MUSiC",
    "SFXFormat": "SOUND",
    "Options": "OPTiONS",
    "TutorialDone": "TUTORiAL OUTRO",
    "Restart": "RETRY",
    "Continue": "CONTiNUE",
    "Quit": "QUiT",
    "MainMenu": "MAiN MENU",
    "Pause": "PAUSE",
    "Play": "PLAY",
    "Empty": "EMPTY",
    "PowerupInventory": "POWER-UP iNVENTORY",
    "General": "GENERAL",
    "AnyMode": "Any Mode",
    "EasyModeLow": "Normal Mode",
    "EasyMode": "NORMAL MODE",
    "NormalModeLow": "Match Mode",
    "NormalMode": "MATCH MODE",
    "SkullModeLow": "Skull Mode",
    "SkullMode": "SKULL MODE",
    "TimedModeLow": "Timed Mode",
    "TimedMode": "TiMED MODE",
    "ZenModeLow": "Zen Mode",
    "ZenMode": "ZEN MODE",
    "Zen": "ZEN",
    "RestorePurchases": "RESTORE PURCHASES",
    "ReportProblem": "REPORT A PROBLEM",
    "GameRank": "Player Rank",
    "RainbowFruitDescription": "RAiNBOW FRUiT",
    "Perks": "PERKS",
    "CoconutBomb": "COCONUT BOMB",
    "Powerups": "POWER-UPS",
    "ClockMagnet": "CLOCK MAGNET",
    "FruitSmasher": "FRUiT HAMMER",
    "SkullSmasherTitle": "SKULL SMASHER",
    "Barrier": "BLOB BARRiER",
    "TheNuke": "PANiC BUTTON",
    "TNTBlobs": "TNT BLOBS",
    "ScoreMultiplier": "CHERRY BONUS",
    "ChainBonus": "BONUS BOOSTER",
    "UpgradeShop": "SHOPPE",
    "UnlockBonusReward": "BONUS REWARD:",
    "UnlockedTitle": "UNLOCKED!",
    "UnlockRequirements": "UNLOCK REQUiREMENTS",
    "EliteCoinsReward": "FREE COiNS",
    "EliteCoinsRewardDescription": "+5,000 Coins",
    "NewsMenuText1": "Check out these other games!",
    "NewsMenuText2": "Only the best of the best here...",
    "NewsMenuText3": "If you like games, you've come to the right place.",
    "NewsMenuText4": "Have you tried out these games?",
    "MalModeSelectDescriptionEasy": "Keep back the rising blobs!",
    "MalModeSelectDescriptionNormal": "Make color matches for big points!",
    "MalModeSelectDescriptionTimed": "Speed is the name of the game!",
    "MalModeSelectDescriptionSkull": "Destroy the skull blobs before they explode!",
    "MalModeSelectDescriptionComingSoon": "Stay tuned for more content!",
    "LevelFormat": "WAVE {0}",
    "GameOverBlobOverflow1": "Blob over, man, blob over!",
    "GameOverBlobOverflow2": "I've been blobbed!",
    "GameOverBlobOverflow3": "The blob also rises!",
    "GameOverBlobOverflow4": "I hope I give this blob an upset stomach.",
    "GameOverBlobOverflow5": "I've been digested.",
    "GameOverBlobOverflow6": "It's kinda warm in here.",
    "GameOverBlobOverflow7": "Drats! Eaten.",
    "GameOverBlobOverflow8": "Drats! Eaten... ... Again.",
    "GameOverBlobOverflow9": "They got me!",
    "GameOverBlobOverflow10": "Absorbed!",
    "GameOverBlobOverflow11": "Dinner is served. I guess it's me.",
    "GameOverBlobOverflow12": "This is quite the predicament.",
    "GameOverBlobOverflow13": "Actually, it's pretty cozy in here.",
    "GameOverBlobOverflow14": "Wait! I surrender!",
    "GameOverBlobOverflow15": "...",
    "GameOverBlobOverflow16": "Not as bad as I thought it'd be.",
    "GameOverBlobOverflow17": "Think I'll stay in here a while.",
    "GameOverBlobOverflow18": "You'll get yours, blob.",
    "GameOverBlobOverflow19": "Gross!",
    "GameOverBlobOverflow20": "Just chillin'.",
    "GameOverTimeUp1": "Oh noes!!! Outta time!",
    "GameOverTimeUp2": "No time left!",
    "GameOverTimeUp3": "Time ain't on my side!",
    "GameOverTimeUp4": "Outta Time!",
    "GameOverTimeUp5": "Time has expired like old milk. Yuck!",
    "GameOverTimeUp6": "Over? Already?!",
    "GameOverTimeUp7": "It's like the end of time!",
    "GameOverTimeUp8": "Time out!",
    "GameOverTimeUp9": "Time wasn't on my side.",
    "GameOverTimeUp10": "Time's up!",
    "GameOverTimeUp11": "Yikes!",
    "GameOverTimeUp12": "Where did all the time go?",
    "GameOverTimeUp13": "Hard times.",
    "GameOverTimeUp14": "Good times.",
    "GameOverTimeUp15": "What a buzz(er) kill.",
    "GameOverTimeUp16": "It was only a matter of time.",
    "GameOverCountdownExpired1": "Do you smell somethin' roasting?",
    "GameOverCountdownExpired2": "Do you think this gas is poisonous?",
    "GameOverCountdownExpired3": "I can't feel my legs! Wait, I don't have legs.",
    "GameOverCountdownExpired4": "I think I'm gonna hurl.",
    "GameOverCountdownExpired5": "Barf!",
    "GameOverCountdownExpired6": "I'm seein' skulls.",
    "GameOverCountdownExpired7": "I don't feel so good.",
    "GameOverCountdownExpired8": "Rats! Poisoned!",
    "GameOverCountdownExpired9": "Curses! I've been cursed!",
    "GameOverCountdownExpired10": "Feeling under the weather...",
    "GameOverCountdownExpired11": "Braaiins!",
    "GameOverCountdownExpired12": "Gross!",
    "GameOverCountdownExpired13": "That blob put a spell on me.",
    "GameOverCountdownExpired14": "Does this mean I'm a zombie now?",
    "GameOverCountdownExpired15": "There's a light. I'm headin' towards it.",
    "GameOverCountdownExpired16": "One of us... One of us...",
    "GameOverCountdownExpired17": "I been voodooed!",
    "GameOverFruitOverflow1": "Fruit Avalanche!",
    "GameOverFruitOverflow2": "I've been fruited!",
    "GameOverFruitOverflow3": "Snappy fruit related quip goes here!",
    "GameOverFruitOverflow4": "For fruit's sake!",
    "GameOverFruitOverflow5": "Too much Vitamin C!",
    "GameOverFruitOverflow6": "Fruit 'splosion!",
    "GameOverFruitOverflow7": "Ahhhhhhhhhh!",
    "GameOverFruitOverflow8": "Oof!",
    "GameOverFruitOverflow9": "Fruit avalanche!",
    "GameOverFruitOverflow10": "These fruits are dynamite.",
    "GameOverFruitOverflow11": "The fruit backfired on me!",
    "GameOverFruitOverflow12": "Death by fruit.",
    "GameOverFruitOverflow13": "Fruitpocalypse!",
    "GameOverFruitOverflow14": "And we have liftoff.",
    "GameOverFruitOverflow15": "Fruitnami!",
    "GameOverFruitOverflow16": "Fruit salad.",
    "GameOverFruitOverflow17": "Whoa!",
    "GameOverGeneric1": "Graham crackers!",
    "GameOverGeneric2": "Chocolate fudge!",
    "GameOverGeneric3": "Pineapples!",
    "GameOverGeneric4": "C'est la vie... I don't even know what that means.",
    "GameOverGeneric5": "Marsh Mom told me I'd have days like this.",
    "GameOverGeneric6": "Fudge!",
    "GameOverGeneric7": "Game over, duder!",
    "GameOverGeneric8": "It's game over for me.",
    "GameOverGeneric9": "Oh noes! Game over.",
    "GameOverGeneric10": "Oops!",
    "GameOverGeneric11": "You win some, you lose some!",
    "GameOverGeneric12": "That's all she wrote.",
    "GameOverGeneric13": "Aw, snap!",
    "GameOverGeneric14": "Finito.",
    "GameOverGeneric15": "Fin!",
    "GameOverGeneric16": "The end.",
    "GameOverGeneric17": "That's it!",
    "GameOverGeneric18": "We've gone off the rails.",
    "GameOverGeneric19": "All's well that ends well.",
    "GameOverGeneric20": "It's a wrap.",
    "GameOverGeneric21": "It's a done deal.",
    "GameOverWin1": "I am winner!",
    "GameOverWin2": "That was easy! Wasn't it?",
    "GameOverWin3": "I am the champion!",
    "GameOverWin4": "Too easy!",
    "GameOverWin5": "Take that, blobs!",
    "GameOverWin6": "Who's the greatest marshmallow? That's right. Me!",
    "GameOverWin7": "I showed those blobs who's boss!",
    "GameOverWin8": "Mission complete!",
    "GameOverWin9": "We did it!",
    "GameOverWin10": "Hot chocolate!",
    "GameOverWin11": "It's my marshday! It's my marshday!",
    "GameOverWin12": "We defeated them blobs!",
    "TutorialPassed": "Hot chocolate! Mission accomplished!",
    "RankFormat": "RANK {0}",
    "Earned": "EARNED:",
    "XPEarned": "+XP:",
    "StatsRankFormat": "Player Rank: {0}",
    "Ready": "READY?",
    "Set": "SET",
    "Go": "GO!",
    "ReachedMaxLevelWin": "WiNNER!",
    "TimeUp": "TiME UP",
    "NextWave": "NEXT WAVE!",
    "TutorialHowToPop": "POP THE FULL BLOB!",
    "TutorialHowToRotate": "DRAG LEFT OR RiGHT TO ROTATE THE COLUMN!",
    "TutorialFastDrop": "QUiCKLY SWiPE DOWN TO FAST DROP FRUiT!",
    "TutorialBombs": "USE THE COCONUT BOMB POWER-UP!",
    "TutorialEasyMode1": "KEEP BACK THE RiSiNG BLOBS FOR AS LONG AS POSSiBLE!",
    "TutorialEasyMode2": "USE POWER-UPS WHEN YOU'RE iN TROUBLE!",
    "TutorialEasyMode3": "THiS METER SHOWS THE RATE BLOBS RiSE!",
    "TutorialTimedMode1": "ACT FAST BEFORE TiME iS UP!",
    "TutorialTimedMode2": "COLLECT CLOCKS TO EXTEND PLAYTiME!",
    "TutorialSkullMode1": "DESTROY COUNTDOWN SKULLS BEFORE THEY DETONATE!",
    "TutorialSkullMode2": "SURViVE FOR AS LONG AS POSSiBLE!",
    "TutorialNormalMode1": "FOUR BLOBS iS TWiCE AS HARD!",
    "TutorialNormalMode2": "MAKE COLOR MATCHES FOR MAJOR POiNTS!",
    "RequirementsUnknown": "???",
    "BlobsPopped": "Total",
    "BlobsStats": "BLOBS POPPED",
    "OrangePopped": "Orange",
    "GreenPopped": "Green",
    "BluePopped": "Blue",
    "RedPopped": "Red",
    "YellowPopped": "Yellow",
    "PinkPopped": "Pink",
    "PurplePopped": "Purple",
    "BrownPopped": "Brown",
    "MoonPopped": "Moon",
    "TurquoisePopped": "Turquoise",
    "FruitPopped": "Fruit Popped",
    "HighScoreEasy": "Highest Score Ever!",
    "HighScore": "Highest Score Ever!",
    "HighCombo": "Biggest Chain Score",
    "HighScoreTimed": "Highest Score Ever!",
    "HighClocks": "High Clocks Collected",
    "HighScoreCountdown": "Highest Score Ever!",
    "HighCountdownSkulls": "High Skulls Crushed",
    "LastGame": "LATEST GAME",
    "LastGameSequences": "Number of Color Matches",
    "HighSequenceBonus": "Highest Number of Color Matches",
    "LastGameScore": "Score",
    "LastGameCombo": "Biggest Chain Score",
    "LastGameLevel": "Wave Reached",
    "HighestLevel": "Highest Wave",
    "LastShapeBonus": "Tetrominos",
    "BeatEasyMode": "Completed Games",
    "BeatNormalMode": "Completed Games",
    "BeatTimedMode": "Completed Games",
    "BeatSkullMode": "Completed Games",
    "TutorialModeStat": "Tutorial",
    "EasyModeStat": "Normal",
    "NormalModeStat": "Match",
    "ZenModeStat": "Zen",
    "SkullModeStat": "Skull",
    "TimedModeStat": "Timed",
    "TotalPlayTime": "Total Time Played",
    "LastSkulls": "Skulls Smashed",
    "LastGameModePlayed": "Last Game Mode Played",
    "LastClocks": "Clocks Collected",
    "TotalGamesPlayed": "Total Games Played",
    "EasyGamesPlayed": "Games Played",
    "NormalGamesPlayed": "Games Played",
    "TimedGamesPlayed": "Games Played",
    "SurvivalGamesPlayed": "Games Played",
    "CumulativeScoreEasy": "Normal Mode Cumulative Score",
    "CumulativeScoreNormal": "Match Mode Cumulative Score",
    "CumulativeScoreTimed": "Timed Mode Cumulative Score",
    "CumulativeScoreSurvival": "Skull Mode Cumulative Score",
    "CumulativeClocks": "Total Clocks Collected",
    "CumulativeCountdownSkulls": "Total Skulls Smashed",
    "HighShapeBonus": "Most Tetrominos",
    "ShapeBonus": "TETROMiNO!",
    "SequenceBonus": "COLOR MATCH!",
    "SequenceComplete": "COMPLETE!",
    "Magic8": "MAGiC EiGHT!",
    "SixString": "SiX STRiNG!",
    "Blackjack": "BLACKJACK!",
    "MushroomBlobsPopped": "Mushroom Blobs Popped",
    "HighestNumberInChain": "Biggest Chain",
    "Skip": "SKiP",
    "SkipMission": "SKiP MiSSiON?",
    "GamePlayTip1": "Pro-tip: Use fruit to connect groups of blobs.",
    "GamePlayTip2": "3 (or more) fruit in a row will explode. This is useful for getting rid of excess fruit.",
    "GamePlayTip3": "Don't let the back of the column sneak up on you.",
    "GamePlayTip4": "RAINBOW FRUIT are loved by all blobs. They must taste pretty great.",
    "GamePlayTip5": "Drag down to fast drop fruit.",
    "GamePlayTip6": "Some items, like the SKULL SMASHER and CLOCK MAGNET, are only available in specific game modes.",
    "GamePlayTip7": "Don't forget to power up those power-ups!",
    "GamePlayTip8": "Always keep the opposite side of the column in mind.",
    "GamePlayTip9": "The benefits of upgrading perks and power-ups is HUGE, I tell ya.",
    "GamePlayTip10": "Once a blob is filled with a fruit, touching it will pop the blob.",
    "GamePlayTip11": "Blobs will spit out what they have inside if their favorite fruit lands on them.",
    "GamePlayTip12": "Blobs will release their contents when popped as part of a chain.",
    "GamePlayTip13": "If you don't have an immediate use for a fruit, try to find a spot it will be useful later.",
    "GamePlayTip14": "Ultimate pro-tip: Don't let the blobs reach the top.",
    "GamePlayTip15": "Keep an eye on the dashed line. It shows the max height of the stack!",
    "GamePlayTip16": "These blobs are picky eaters! They only like fruits the same color as themselves.",
    "GamePlayTip17": "You don't have to activate perks once you unlock or upgrade them. Totally convenient!",
    "GamePlayTip18": "Make sure you have enough power-ups before heading out. Don't wanna be caught unprepared.",
    "GamePlayTip19": "Stock up on power-ups so you can use them when you need them.",
    "GamePlayTip20": "You can upgrade both power-ups and perks. Doing so makes them better, or so I'm told.",
    "GamePlayTip21": "Some marshmallows like wearing accessories. I am one of those marshmallows.",
    "GamePlayTip22": "Spend your hard-earned coins in the SHOPPE. I'm sure you'll find something useful there.",
    "GamePlayTip23": "Sometimes one just needs a new hat. Check out all the MALWEAR you can equip in the Shoppe.",
    "GamePlayTip25": "TNT blobs cause a big explosion when popped. But that's pretty obvious.",
    "GamePlayTip26": "Sleeping blobs won't eat fruit and can only be destroyed in a chain.",
    "GamePlayTip27": "MUSHROOMS make blobs sleepy so they won't eat fruit. They can only be destroyed in a chain.",
    "GamePlayTip28": "Earn a TETROMINO by popping precisely four blobs in a chain. No matching fruit can be touching the blobs though!",
    "GamePlayTip29": "Pop exactly 21 blobs in a chain to get the BLACKJACK bonus for HUGE points!",
    "GamePlayTip30": "Popping chains of certain numbers of blobs gives bonuses. Try to find them all!",
    "GamePlayTip31": "Popping exactly 6 blobs in a chain will give the SIX STRING bonus. Rock!",
    "GamePlayTip32": "Get the MAGIC EIGHT bonus by popping exactly 8 blobs in a chain. Feel the magic!",
    "GamePlayTip33": "Watch out for flaming skulls. They have short fuses!",
    "GamePlayTip34": "Look for special clocks that give more time.",
    "GamePlayTip35": "Subsequent Color Matches yield increased score bonuses... I dunno what I just said.",
    "GamePlayTip36": "When you're all out of options, the PANIC BUTTON can save your marshmallow!",
    "GamePlayTip37": "When the blobs are knocking at the gates, put up a gate. Use the BARRIER!",
    "GamePlayTip38": "RAINBOW FRUITS are great for Color Matching in Match Mode.",
    "TipPassholder": "Become a Robot Invader Passholder to get exclusive content!",
    "TipAddTime": "Running out of time? The TIME BONUS perk gives you precious extra seconds at the start of Timed Mode.",
    "TipCherryBonus": "Not getting the points you want? Get a percentage bonus based on total score with the CHERRY BONUS perk!",
    "TipChainBonus": "The BONUS BOOSTER perk increases the points received by static bonuses like Six String. A serious score enhancer!",
    "TipTNT": "TNT perk causes explosive TNT blobs to spawn sometimes. Upgrading the perk, increases their frequency and explosive power!",
    "TipNeedCoins": "Low on coins? You can purchase COIN BUNDLES in the Shoppe.",
    "TipSpendCoins": "Spend your coins in the SHOPPE! Treat yourself right!",
    "TipCoinDoubler": "Earn coins twice as fast with the COIN/XP DOUBLER. Not to mention it also doubles XP so you Rank Up faster!",
    "ElitePackDescription": "Get EXCLUSIVE content: Wind-up Knight Stage! Special Malwear! MOON Stage! MUSHROOM Mode! A Passholder BADGE on the leaderboards! +5,000 coins! What a deal!",
    "TipPassholder2": "Get exclusive Malwear, Wind-up Knightmare and Moon Stages when you purchase the ROBOT INVADER PASS! Join today!",
    "TipUnlockAll": "You can INSTANT UNLOCK standard Modes, Stages, and Level 1 Power-ups in the Shoppe!",
    "TipRainbowFruit": "Unlock the useful RAINBOW FRUIT perk and you'll be able to match it to any blob! Upgrade it to increase the frequency it appears!",
    "TipClockMagnet": "The CLOCK MAGNET is essential in Timed Mode! Collect clocks at the press of a button!",
    "TipSkullSmasher": "The SKULL SMASHER can really help with those hard to reach skulls in Skull Mode!",
    "TipUpgrades": "UPGRADE your power-ups to make them more powerful!",
    "TipPerks": "PERKS never run out, but upgrading makes them more powerful or appear more frequently!",
    "TipMalwear": "Equip MALWEAR for fashionable play!",
    "TipMalwear2": "MALWEAR makes you look cool. Browse all the latest fashions in the Shoppe!",
    "TipCoconutBombs": "Don't forget to keep stocked up on COCONUT BOMBS!",
    "GameOverMenuText1": "Just one more round!",
    "GameOverMenuText2": "Hey, that was a good run!",
    "GameOverMenuText3": "Not too shabby...",
    "GameOverMenuText4": "That's what I'm talkin 'bout!",
    "GameOverMenuText5": "Another game, perhaps?",
    "GameOverMenuText6": "Ain't nothin' stopping us now.",
    "GameOverMenuText7": "Again!",
    "GameOverMenuText8": "One more!",
    "GameOverMenuText9": "That was fun!",
    "GameOverMenuText10": "Intense!",
    "GameOverMenuText11": "Good times!",
    "GameOverMenuText12": "Let's go another round!",
    "GameOverZeroText": "What happened?!",
    "AchievementsMenuText1": "Check out all those achievements. Have you unlocked them all?",
    "AchievementsMenuText2": "Nothin' wrong with trying to collect all the achievements.",
    "AchievementsMenuText3": "The score on the right is a good indication of the difficulty of an achievement.",
    "AchievementsMenuText4": "Marshmallows are all about achievements!",
    "GameSetupMenuText1": "Stock up on power-ups now if you're low!",
    "GameSetupMenuText2": "Let's get started! Choose your battleground!",
    "GameSetupMenuText3": "What stage should we tackle now?",
    "TutorialPart1Text1": "Hi, I'm MARSH MAL! I'm a marshmallow but that goes without saying.",
    "TutorialPart1Text2": "Have you heard? The world is being overrun with BLOBS! But I know how to stop them!",
    "TutorialPart1Text3": "How? Blobs love FRUIT! Once a blob has eaten fruit, you can pop it! Ready to see it in action?",
    "TutorialHowToPlay1": "DROP FRUiT iNTO A BLOB OF MATCHiNG COLOR!",
    "TutorialHowToPlay2": "THEN POP iT TO EXPLODE TOUCHiNG BLOBS OF THE SAME COLOR!",
    "TutorialPart3Text1": "Power-ups are pretty great, huh? You can use the COINS you collect to UPGRADE them or get more when you run out!",
    "TutorialPart3Text2": "You can also unlock powerful, permanent PERKS, which will help you automatically as you play!",
    "TutorialPart3Text3": "Use power-ups and perks to help land some MEGA SCORES! Now let's get crackin'!",
    "TutorialMenus1": "SELECT YOUR MODE HERE.",
    "TutorialMenus1b": "MORE MODES WiLL UNLOCK AS YOU PLAY!",
    "TutorialMenus2": "EACH STAGE HAS A DiFFERENT ASSORTMENT OF BLOBS!",
    "TutorialMenus2b": "MORE STAGES WiLL UNLOCK AS YOU PLAY!",
    "TutorialMenus3": "LOGiN TO COMPARE HiGH SCORES WiTH FRiENDS!",
    "TutorialMenus4": "YOU CAN SPEND YOUR COiNS AT THE SHOPPE!",
    "TutorialMenus4b": "STOCK UP ON POWER-UPS OR GET SOME PERKS!",
    "MalTutorialText1": "Let's pop some blobs!",
    "MalTutorialText2": "Look out below!",
    "MalTutorialText3": "Nice! A chain reaction!",
    "MalTutorialText4": "Pop that blob!",
    "MalTutorialText5": "Now try out a power-up!",
    "MalTutorialText6": "BOOOOOM!",
    "StatsMenuText1": "Marshmallows ain't the best with numbers, honestly.",
    "PowerupSetupMenuText1": "COCONUT BOMBS are great when you're in a jam.",
    "PowerupSetupMenuText2": "Use the BARRIER as a last ditch effort to temporarily keep back the blobs.",
    "PowerupSetupMenuText3": "The PANIC BUTTON will completely reset the stack. Use it for good, not evil.",
    "PowerupSetupMenuText4": "CLOCK MAGNET is great for grabbin' those hard to reach clocks.",
    "PowerupSetupMenuText5": "Use the SKULL SMASHER if you can't destroy a skull before it detonates.",
    "StatsMenuText2": "I <3 numbers and stuff!",
    "StatsMenuText3": "Whoa! Look at all those numbers and things.",
    "StatsMenuText4": "What's it all mean?",
    "StatsMenuText5": "Look at them stats!",
    "StatsMenuText6": "Some people are bored by stats.  Zzzzzzzz...",
    "StoreMenuText1": "Use your coins to upgrade to more powerful power-ups and perks!",
    "StoreMenuText2": "If you want to play to win, it helps to have leveled up power-ups and perks!",
    "StoreMenuText3": "Perks are active whenever you play and really help to boost your score!",
    "StoreMenuText4": "The more you upgrade, the more powerful your power-ups and perks get.",
    "StoreMenuMalwearText1": "Look at all the choices!",
    "StoreMenuMalwearText2": "Sometimes you just want something nice to wear.",
    "StoreMenuMalwearText3": "Dressing up is not just for fancy occasions.",
    "StoreMenuMalwearText4": "I dress for fashion, not function.",
    "StoreMenuInventoryText1": "Don't forget to stock up on power-ups!",
    "StoreMenuInventoryText2": "Power-ups can really help you out of a jam.",
    "StoreMenuInventoryText3": "Got enough power-ups? You don't want to run out in the middle of a game!",
    "StoreMenuInventoryText4": "Use power-ups in times of crisis!",
    "BombDescription": "Destroys ALL blobs of the same color when absorbed. Ultra useful!",
    "ClockMagnetDescription": "Pulls clocks from blobs! Upgrade to pull more clocks.",
    "SkullSmasherDescription": "Destroys most dangerous skulls on use!",
    "FruitSmasherDescription": "Get rid of the loose fruit junking up the board!",
    "TheNukeDescription": "In a tough spot? Trigger the PANIC BUTTON to blow up the entire board!",
    "StackPauseDescription": "Increase the number of turns before the stack rises.",
    "BarrierDescription1": "Block blobs and fruit from reaching the top for a number of turns.",
    "UpgradeLevel": "LEVEL {0}",
    "BarrierDescription2": "Decrease Cooldown 10%, Lasting Turns +2",
    "BarrierDescription3": "Decrease Cooldown 15%, Lasting Turns +4, Destroys extra row",
    "BarrierDescription4": "Decrease Cooldown 25%, Lasting Turns +6, Destroys extra row",
    "BarrierDescription5": "Decrease Cooldown 40%, Lasting Turns +8, Destroys 2 extra rows",
    "BombUpgradeDescription1": "Destroy all blobs of the same color when a blob absorbs a bomb.",
    "BombUpgradeDescription2": "Decrease Cooldown 10%, Increase Score",
    "BombUpgradeDescription3": "Decrease Cooldown 15%, Increase Score+",
    "BombUpgradeDescription4": "Decrease Cooldown 25%, Increase Score++",
    "BombUpgradeDescription5": "Decrease Cooldown 40%, Increase Score+++",
    "ComboChainUpgradeDescription1": "Increase static bonus scores (excludes scaling bonuses)",
    "ComboChainUpgradeDescription2": "Static Bonus Scores x2",
    "ComboChainUpgradeDescription3": "Static Bonus Scores x2.5",
    "ComboChainUpgradeDescription4": "Static Bonus Scores x3",
    "ComboChainUpgradeDescription5": "Static Bonus Scores x5",
    "ClockMagnetUpgradeDescription1": "Automatically capture a number of clocks from blobs.",
    "ClockMagnetUpgradeDescription2": "Capture up to 5 clocks, Decrease Cooldown 10%",
    "ClockMagnetUpgradeDescription3": "Capture up to 8 clocks, Decrease Cooldown 15%",
    "ClockMagnetUpgradeDescription4": "Capture up to 10 clocks, Decrease Cooldown 25%",
    "ClockMagnetUpgradeDescription5": "Capture up to 12 clocks, Decrease Cooldown 40%",
    "FruitSmasherUpgradeDescription1": "Wipes out a number of loose fruit junking up the board!",
    "FruitSmasherUpgradeDescription2": "Smash up to 15 fruits, Decrease Cooldown 10%",
    "FruitSmasherUpgradeDescription3": "Smash up to 20 fruits, Decrease Cooldown 15%",
    "FruitSmasherUpgradeDescription4": "Smash up to 30 fruits, Decrease Cooldown 25%",
    "FruitSmasherUpgradeDescription5": "Smash up to 40 fruits, Decrease Cooldown 40%",
    "CountdownDestroyUpgradeDescription1": "Automatically smashes the most dangerous skull",
    "CountdownDestroyUpgradeDescription2": "Smash up to 2 skulls, Decrease Cooldown 10%",
    "CountdownDestroyUpgradeDescription3": "Smash up to 3 skulls, Decrease Cooldown 15%",
    "CountdownDestroyUpgradeDescription4": "Smash up to 4 skulls, Decrease Cooldown 25%",
    "CountdownDestroyUpgradeDescription5": "Smash up to 6 skulls, Decrease Cooldown 40%",
    "NukeUpgradeDescription1": "Blows up all the blobs onscreen! A most powerful weapon!",
    "NukeUpgradeDescription2": "Decrease Cooldown 7%, Increase Score",
    "NukeUpgradeDescription3": "Decrease Cooldown 10%, Increase Score+",
    "NukeUpgradeDescription4": "Decrease Cooldown 13%, Increase Score++",
    "NukeUpgradeDescription5": "Decrease Cooldown 20%, Increase Score+++",
    "RainbowFruitUpgradeDescription1": "Occasionally spawn Rainbow Fruits which are absorbed by any color blobs.",
    "RainbowFruitUpgradeDescription2": "Increase Probability x2",
    "RainbowFruitUpgradeDescription3": "Increase Probability x3",
    "RainbowFruitUpgradeDescription4": "Increase Probability x4",
    "RainbowFruitUpgradeDescription5": "Increase Probability x6",
    "ScoreMultiplierUpgradeDescription1": "Added Bonus, based on a % of your total score.",
    "ScoreMultiplierUpgradeDescription2": "Bonus Score",
    "ScoreMultiplierUpgradeDescription3": "Bonus Score",
    "ScoreMultiplierUpgradeDescription4": "Bonus Score",
    "ScoreMultiplierUpgradeDescription5": "Bonus Score",
    "TNTUpgradeDescription1": "Some blobs will contain TNT, which causes a radial explosion!",
    "TNTUpgradeDescription2": "Increase Probability, Increase Score",
    "TNTUpgradeDescription3": "Increase Probability+, Increase Score+",
    "TNTUpgradeDescription4": "Increase Probability++, Increase Score++",
    "TNTUpgradeDescription5": "Increase Probability+++, Increase Score+++",
    "TutorialMenuUpgrades": "UPGRADE YOUR POWER-UPS HERE",
    "TutorialMenuPerks": "UNLOCK AND UPGRADE PERMANENT PERKS HERE",
    "TutorialMenuCoinStore": "GET MORE COiNS HERE",
    "TutorialMenuSpecialOffers": "ViEW SPECiAL OFFERS HERE",
    "TutorialMenuMalwear": "UNLOCK FASHiONABLE MALWEAR HERE",
    "TutorialMenuInventory": "REPLENiSH YOUR POWER-UP iNVENTORY HERE",
    "NextUpgradeFormat": "Next: {0}",
    "CompletionBonus": "FiNiSH BONUS!",
    "Instaskull": "SKULL SHOT!",
    "SuperSkullShot": "SUPER SKULL SHOT!",
    "CloseCall": "CLOSE CALL!",
    "Unlock": "UNLOCK",
    "ClearBoardBonus": "CLEAR BONUS!",
    "Max": "MAX!",
    "AchievementWhoMadeThis": "WHO MADE THiS GAME??!",
    "AchievementWhoMadeThisFormat": "Watch the credits",
    "AchievementUnlockExpert": "PROFESSiONAL",
    "AchievementNormalMode": "NOR-MAL",
    "AchievementExpertGames": "MATCH MAKER",
    "AchievementExpertGamesUnlockFormat": "Play {0} games of Match Mode",
    "FruitPoppedFormat": "Blow up loose FRUIT {0} times",
    "NormalModeUnlockFormat": "Play {0} games in Skull Mode",
    "TimedModeUnlockFormat": "Play {0} games in Normal Mode",
    "SkullModeUnlockFormat": "Play {0} games in Timed Mode",
    "ArcticAreaUnlockFormat1": "Achieve Player Rank {0}",
    "DesertAreaUnlockFormat1": "Achieve Player Rank {0}",
    "CandyAreaUnlockFormat1": "Achieve Player Rank {0}",
    "ForestAreaUnlockFormat1": "Achieve Player Rank {0}",
    "SwampAreaUnlockFormat1": "Achieve Player Rank {0}",
    "AchievementPumpkinPi": "PUMPKiN Pi",
    "AchievementPumpkinPiFormat": "Pop a cumulative total of 314 pumpkins",
    "AchievementFunGuy": "FUN GUY",
    "AchievementFunGuyFormat": "Pop {0} Mushrooms in a single game of Match Mode",
    "AchievementColorCoordinator": "COLOR COORDiNATOR",
    "AchievementColorCoordinatorFormat": "Get {0} Color Matches in one game of Match Mode",
    "AchievementSunriseFormat": "Reach wave 10 in a game of Match Mode",
    "AchievementFashionableFormat": "Unlock {0} pieces of Malwear",
    "AchievementNormalFormat": "Play {0} Normal Mode games",
    "AchievementClockheadFormat": "Play {0} Timed Mode games",
    "AchievementCursesFormat": "Play {0} games of Skull Mode",
    "AchievementStrawberryForeverFormat": "Pop a total of {0} Red blobs",
    "AchievementSkullSmasherFormat": "Destroy {0} skulls in a single game of Skull Mode",
    "AchievementPuckerUpFormat": "Pop a total of {0} Yellow blobs",
    "AchievementWatchMakerFormat": "Play {0} Timed Mode games",
    "AchievementBoneHeadFormat": "Play {0} Skull Mode games",
    "AchievementUnlockExpertFormat": "Play {0} Match Mode games",
    "AchievementYouGotLearnedFormat": "Complete the Tutorial",
    "AchievementRankLowFormat": "Achieve Player Rank {0}",
    "AchievementRankMediumFormat": "Achieve Player Rank {0}",
    "AchievementRankHighFormat": "Achieve Player Rank {0}",
    "AchievementBlobsAwayFormat": "Pop a chain of at least {0} blobs without using a power-up",
    "AchievementDaBombFormat": "Use {0} Coconut bombs",
    "AchievementMaximumPowerFormat": "Max out a Power-up or Perk upgrade",
    "AchievementTimeCopFormat": "Collect {0} clocks in one game of Timed Mode",
    "AchievementLucky7Format": "Create a chain of 7 fruit",
    "AchievementTetrominoMaestroFormat": "Get {0} tetrominos in a row",
    "AchievementWasteTheRainbowFormat": "Match 3 or more rainbow fruit",
    "AchievementDestroyerOfBlobsFormat": "Pop a total of {0} blobs. Do it!",
    "AchievementEnvironmentalistFormat": "Unlock a new stage",
    "AchievementANewChallengerFormat": "Invite a friend to play the game",
    "AchievementTetrominorFormat": "Get {0} tetrominos in a row",
    "AchievementMillionaireMalFormat": "Score at least {0} points in a game of Match Mode",
    "AchievementMoonBlobsFormat": "Pop a total of {0} moon blobs",
    "AchievementBeatEasyFormat": "Complete the 25th Wave in Normal Mode",
    "AchievementBeatNormalFormat": "Complete the 25th Wave in Match Mode",
    "AchievementBeatSkullFormat": "Complete the 25th Wave in Skull Mode",
    "AchievementBeatTimedFormat": "Complete the 25th Wave in Timed Mode",
    "AchievementWindUpKnight": "SCALE THE CASTLE",
    "AchievementWindUpKnightDescription": "Complete the 25th Wave in the Wind-up Knightmare Stage (Any Mode)",
    "AchievementBeatEasy": "BEAT iT",
    "AchievementBeatNormal": "DON'T STOP BELiEViNG",
    "AchievementBeatSkull": "THE FiNAL COUNTDOWN",
    "AchievementBeatTimed": "TiME AFTER TiME",
    "AchievementNatureFreakFormat1": "Unlock 5 stages",
    "AchievementPowerUpSlot2Format": "Reach Player Rank {0}",
    "AchievementPowerUpSlot3Format": "Reach Player Rank {0}",
    "UnlockSkullSmasherItemTask1": "Play {0} Game of Skull Mode",
    "UnlockClockMagnetTask1": "Play {0} Game of Timed Mode",
    "UnlockNukeTask1": "Play {0} Games Total",
    "UnlockNukeTask2": "Get {0} cumulative points in Match Mode.",
    "UnlockCoinMagnetFormat1": "Reach Player Rank {0}",
    "UnlockBarrierFormat1": "Play {0} Games Total",
    "UnlockFruitSmasherFormat1": "Play {0} Games Total",
    "UnlockMoonArea": "Become a Passholder to get this Exclusive Stage!",
    "UnlockWukArea": "Become a Passholder to get this Exclusive Stage!",
    "ArcticArea": "ARCTiC STAGE",
    "DesertArea": "DESERT STAGE",
    "SwampArea": "SWAMP STAGE",
    "CandyArea": "CANDY STAGE",
    "ForestArea": "FOREST STAGE",
    "Clockhead": "CLOCKHEAD",
    "MoonArea": "MOON STAGE",
    "WukArea": "WiND-UP KNiGHTMARE",
    "Curses": "CURSES",
    "StrawberryBlobsForever": "STRAWBERRY BLOBS FOREVER",
    "PuckerUp": "PUCKER UP",
    "WatchMaker": "WATCH MAKER",
    "BoneHead": "BONEHEAD",
    "YouGotLearned": "YOU GOT LEARNED",
    "RankLow": "RANK 5",
    "RankMedium": "RANK 10",
    "RankHigh": "RANK 25",
    "BlobsAway": "BLOBS AWAY",
    "DaBomb": "DA BOMB",
    "MaximumPower": "ALL JUiCED UP",
    "TimeCop": "TiME COP",
    "Lucky7": "LUCKY 7",
    "TetrominoMaestro": "TETROMAJOR",
    "WasteTheRainbow": "WASTE THE RAiNBOW",
    "DestroyerOfBlobs": "DESTROYER OF BLOBS",
    "Environmentalist": "ENViRONMENTALiST",
    "ANewChallenger": "A NEW CHALLENGER",
    "Tetrominor": "TETROMiNOR",
    "MillionaireMal": "MiLLiONAiRE MAL",
    "NatureFreak": "NATURE FREAK",
    "Fashionable": "FASHiONABLE",
    "MoonBlobsAchievement": "MOON CHiLD",
    "Sunrise": "ALL-NiGHTER",
    "PowerUpSlot2": "POWER-UP SLOT 2",
    "PowerUpSlot3": "POWER-UP SLOT 3",
    "UnlockProgressFormat": "({0}/{1})",
    "AchievementUnlockedFormat": "ACHiEVEMENT UNLOCKED!\\n{0}",
    "UnlockedFormat": "Unlocked {0}!",
    "CoinDoubler": "COiN/XP DOUBLER",
    "CoinDoublerDescription": "Doubles the worth of currency and XP collected during play! (Does not apply to coin pack purchases or coin/XP rewards)",
    "CoinSKU1": "HAND FULL OF \\n{0} COiNS",
    "CoinSKU2": "BASKET FULL OF \\n{0} COiNS",
    "CoinSKU3": "CRATE FULL OF \\n{0} COiNS",
    "CoinSKU4": "FRiDGE FULL OF \\n{0} COiNS",
    "CoinSKU5": "TRUCK FULL OF \\n{0} COiNS",
    "CoinSKU6": "SiLO FULL OF \\n{0} COiNS",
    "MoreCoinOffers": "GET FREE COiNS\\n{0}",
    "MoreCoinOffersDescription": "A variety of offers for free coins!",
    "AdvancedTip": "ADVANCED TiP",
    "AdvancedTips": "ADVANCED TiPS",
    "SecretAchievement": "SECRET",
    "GameOver": "GAME OVER",
    "Buy": "BUY",
    "TryItOut": "TRY iT OUT!",
    "HelpfulTip": "HELPFUL TiP",
    "CheckItOut": "CHECK iT OUT",
    "UnlockNow": "UNLOCK NOW",
    "UnlockEarly": "You can unlock this early!",
    "TryTimedMode": "TiMED MODE SET!",
    "TrySkullMode": "SKULL MODE SET!",
    "TryExpertMode": "MATCH MODE SET!",
    "TryForestLevel": "FOREST STAGE SET!",
    "TryArcticLevel": "ARCTiC STAGE SET!",
    "TryDesertLevel": "DESERT STAGE SET!",
    "TryWukLevel": "WiND-UP KNiGHTMARE STAGE SET!",
    "TryMoonLevel": "MOON STAGE SET!",
    "TrySwampLevel": "SWAMP STAGE SET!",
    "TryCandylandLevel": "CANDY STAGE SET!",
    "NeedMoreCoins": "You need more coins!",
    "NeedMoreCoinsToUnlockEarly": "You need more coins to unlock this early!",
    "BarrierInventoryFormat": "{0} BLOB BARRiERS",
    "CoconutBombsInventoryFormat": "{0} COCONUT BOMBS",
    "CoconutBombsInventoryDescription": "Blow up blobs of the same color!",
    "CoconutBombsInventoryDescription2": "An assortment of coconuts!",
    "ClockMagnetsInventoryFormat": "{0} CLOCK MAGNETS",
    "FruitSmasherInventoryFormat": "{0} FRUiT HAMMERS",
    "FruitSmasherInventoryDescription": "Pops excess junk fruit!",
    "ClockMagnetInventoryDescription": "Grab clocks from blobs automatically!",
    "SkullMagnetsInventoryFormat": "{0} SKULL SMASHERS",
    "SkullMagnetInventoryDescription": "Smash some skulls with ease!",
    "TheNukeInventoryFormat": "{0} PANiC BUTTONS",
    "BarriersInventoryDescription": "Use them to block overflowing blobs and fruit!",
    "TheNukeInventoryDescription": "Blow up the board! Useful when you're in trouble!",
    "CoinsInventoryFormat": "{0} COiNS",
    "CoinsRewardDescription": "A bunch of coins to use in the Shoppe!",
    "XPRewardFormat": "{0} XP",
    "RewardScreenTitle": "REWARD",
    "RewardScreenDescription": "POP A BLOB TO CLAiM YOUR REWARD!",
    "RewardScreenChoseRewardFormat": "YOU GOT: {0}!",
    "YouGot": "YOU GOT: {0}",
    "Upgrades": "Upgrades",
    "Inventory": "Inventory",
    "Malwear": "Malwear",
    "PerksShoppe": "Perks",
    "SpecialOffersButton": "Offers",
    "CoinStoreTitle": "COiN STORE",
    "Store": "Store",
    "TwitterOffer": "FOLLOW US \\n {0} COiNS",
    "TwitterOfferDescription": "Receive a pool of coins for getting the latest info from @robotinvader on Twitter.",
    "FreeOffersTitle": "FREE OFFERS",
    "SpecialOffersTitle": "SPECiAL OFFERS",
    "InventoryTitle": "iNVENTORY",
    "UpgradesTitle": "UPGRADES",
    "FacebookOffer": "LiKE US \\n {0} COiNS",
    "FacebookOfferButton": "LiKE US",
    "FacebookOfferDescription": "Receive a pool of coins by liking us on Facebook",
    "Details": "DETAiLS",
    "StoreTitle": "STORE",
    "Upgrade": "UPGRADE",
    "TwitterButton": "FOLLOW US",
    "GooglePlusButton": "+1 US",
    "GooglePlus": "+1 US \\n {0} COiNS",
    "GooglePlusDescription": "Receive a pool of coins by keeping up to date with us on Google+",
    "BuyLevelsTitle": "iNSTANT UNLOCK",
    "BuyLevelsTitleDescription": "In a hurry? Instantly unlock Power-ups (Level 1), standard Modes and Stages! (Does not include Passholder exclusive content.)",
    "ElitePackTitle": "ROBOT iNVADER PASS",
    "CoinPacks": "COiN PACKS",
    "StoreSpecialItems": "SPECiAL OFFERS",
    "AreaUp": "Time warp!",
    "SlowDown": "Slow Down!",
    "LastWave": "LAST WAVE!",
    "SpeedUp": "Speed Up!",
    "BestChainFormat": "BEST CHAiN:    {0}",
    "SmashedSkullsFormat": "SMASHED SKULLS:    {0}",
    "ClocksCollectedFormat": "CLOCKS COLLECTED:    {0}",
    "SkullSmasherAchievement": "HEAD HUNTER",
    "CoinsAmountDescription1": "A modest amount of coins for purchase.",
    "CoinsAmountDescription2": "A nice amount of coins to help you out in the game.",
    "CoinsAmountDescription3": "Save some time grinding with this coin pack. Sure to come in handy.",
    "CoinsAmountDescription4": "A good deal of coins! Don't spend them all in one place!",
    "CoinsAmountDescription5": "Now we're talking! This is a better deal than the previous packs, for sure!",
    "CoinsAmountDescription6": "BEST DEAL EVER! A ton of coins to spend however you want.",
    "MalwearHeading1": "SOPHiSTiCATED",
    "MalwearHeading2": "TOUGH",
    "MalwearHeading3": "CUTE",
    "MalwearHeading4": "FUNNY",
    "MalwearHeading5": "SPORTY",
    "MalwearTitle": "MALWEAR",
    "MalwearCop": "OFFiCER",
    "MalwearCopDescription": "Stop criminals in their tracks.",
    "MalwearAfro": "AFRO",
    "MalwearAfroDescription": "The biggest 'do around...",
    "MalwearBandana": "BANDANA",
    "MalwearBandanaDescription": "What are you trying to hide?",
    "MalwearCatMask": "CAT MASK",
    "MalwearCatMaskDescription": "Hello. Kitty.",
    "MalwearChaplin": "BOWLER HAT",
    "MalwearChaplinDescription": "A fitting look for little tramps.",
    "MalwearClown": "CLOWN",
    "MalwearClownDescription": "For those that prefer to clown around.",
    "MalwearCrown": "CROWN",
    "MalwearCrownDescription": "All hail The King of the Column!",
    "MalwearDevilMask": "DEViL MASK",
    "MalwearDevilMaskDescription": "Everybody has a dark side...",
    "MalwearGirlyBow": "GiRLY BOW",
    "MalwearGirlyBowDescription": "It's pretty cute.",
    "MalwearProfessional": "PROFESSiONAL",
    "MalwearProfessionalDescription": "No amateurs, that's the rules.",
    "MalwearGradHat": "GRADUATE",
    "MalwearGradHatDescription": "For true scholars.",
    "MalwearKarateHeadband": "KARATE HEADBAND",
    "MalwearKarateHeadbandDescription": "Hiiiiiya!",
    "MalwearLennonGlasses": "HiPPiE GLASSES",
    "MalwearLennonGlassesDescription": "These retro glasses are rad. And red!",
    "MalwearMardiGras": "MARDi GRAS",
    "MalwearMardiGrasDescription": "A mask for flamboyant types.",
    "MalwearNoveltyGlasses": "NOVELTY GLASSES",
    "MalwearNoveltyGlassesDescription": "For pranksters.",
    "MalwearPirateMate": "PiRATE MATE",
    "MalwearPirateMateDescription": "Ahoy!",
    "MalwearRobberMask": "ROBBER MASK",
    "MalwearRobberMaskDescription": "Don't get any bright ideas...",
    "MalwearSmoresHat": "SMORES HAT",
    "MalwearSmoresHatDescription": "Essential attire for a marshmallow!",
    "MalwearTennisHeadband": "TENNiS HEADBAND",
    "MalwearTennisHeadbandDescription": "Simple and sporty!",
    "MalwearTiara": "PRiNCESS",
    "MalwearTiaraDescription": "For pretty princesses ONLY!",
    "MalwearViking": "ViKiNG",
    "MalwearVikingDescription": "Into pillaging? Then this is the helmet for you.",
    "MalwearMushroom": "MUSHROOM CAP",
    "MalwearMushroomDescription": "Just another toadstool...",
    "MalwearBeret": "BERET",
    "MalwearBeretDescription": "Essential for arty beatniks.",
    "MalwearSurfer": "SURFER",
    "MalwearSurferDescription": "An extreme outfit for outrageous dudes!",
    "MalwearUFO": "UFO iNVADER",
    "MalwearUFODescription": "I want to believe. (Exclusive to Passholders)",
    "MalwearUFODescriptionUnlock": "I want to believe!",
    "MalwearRobotInvaderMask": "ROBOT iNVADER",
    "MalwearRobotInvaderMaskDescription": "Exterminate.",
    "MalwearRobotInvaderMaskUnlockDescription": "Show your allegiance to the Robot Invader crew",
    "MalwearWindupKnightGuard": "CASTLE GUARD",
    "MalwearWindupKnightGuardDescription": "From the critically acclaimed blockbuster hit Wind-up Knight. (Exclusive to Passholders)",
    "MalwearWindupKnight": "WiND UP-KNiGHT",
    "MalwearWindupKnightGuardUnlockDescription": "From Wind-up Knight! Unsurprisingly, he guards the castle.",
    "MalwearWindupKnightDescription": "From the critically acclaimed blockbuster hit Wind-up Knight. (Exclusive to Passholders)",
    "MalwearWindupKnightUnlockDescription": "The iconic helmet of Wind-up Knight!",
    "MalwearArrow": "ARROW",
    "MalwearArrowDescription": "So wild and crazy!",
    "MalwearBasket": "FRUiT BASKET",
    "MalwearBasketDescription": "Perfect place for storing fruit.",
    "MalwearPanhead": "APPLESEED SPECiAL",
    "MalwearPanheadDescription": "Great for boiling water.",
    "MalwearSailor": "SAiLOR",
    "MalwearSailorDescription": "A familiar look.",
    "MalwearScottish": "SCOTSMAN",
    "MalwearScottishDescription": "Is it true what they say about kilts?",
    "MalwearTiki": "TiKi MASK",
    "MalwearTikiDescription": "Essential island attire.",
    "MalwearBaseball": "BASEBALL CAP",
    "MalwearBaseballDescription": "Welcome to the big leagues.",
    "MalwearLuchador": "LUCHADOR",
    "MalwearLuchadorDescription": "For wrestle maniacs.",
    "MalwearCowboy": "COWBOY HAT",
    "MalwearCowboyDescription": "The Good, the Bad and the Fluffy.",
    "MalwearProfessionalText": "I work alone, understand?",
    "MalwearGuardText": "It feels good to be so bad!",
    "MalwearRobotInvaderText": "01110 11011 001 00100!!!1",
    "MalwearUFOText": "Time to abduct some cows!",
    "MalwearkWUKText": "It's a SPRINT to the finish! Haha! Get it?!",
    "MalwearBandanaText": "muffle muffle muffle...",
    "MalwearKarateText": "Karate CHOP!",
    "MalwearPirateText": "Ahoy mateys!",
    "MalwearRobberText": "I'm a smooth criminal.",
    "MalwearSurferText": "I have to go now. My home planet needs me.",
    "MalwearVikingText": "Has anyone seen my battle axe?",
    "MalwearCatMaskText": "Meow!",
    "MalwearGirlyBowText": "Too cute!",
    "MalwearMardiGrasText": "I am SO fashion forward right now!",
    "MalwearTiaraText": "I always consult the Pretty Princess Primer!",
    "MalwearSmoresText": "I feel... complete.",
    "MalwearAppleseedText": "Let's go plant some trees! Woot!",
    "MalwearArrowText": "An odd piercing.",
    "MalwearBasketText": "It might not be fashionable but it IS practical.",
    "MalwearChaplinText": "...",
    "MalwearClownText": "HONK!",
    "MalwearDevilText": "Is it hot in here?",
    "MalwearMushroomText": "I feel like throwing big turnips for some reason.",
    "MalwearNoveltyText": "Hello, I must be going!",
    "MalwearAfroText": "I'm just talkin' 'bout Fruit...",
    "MalwearBeretText": "I'm gonna paint this town red. Literally.",
    "MalwearCrownText": "King me!",
    "MalwearGradText": "I'm feelin' smarter already.",
    "MalwearLennonText": "Imagine a world without blobs. It's easy if you try.",
    "MalwearCopText": "I AM THE LAW!",
    "MalwearSailorText": "Where have I seen this look before?...",
    "MalwearScottishText": "Fore!",
    "MalwearTennisText": "No tennis elbow for me. No elbows either.",
    "MalwearTikiText": "Tiki demands sacrifice!",
    "MalwearBaseballText": "Take me out to the ballgame!",
    "MalwearCowboyText": "Cowboy up!",
    "MalwearLuchadorText": "A winner is me!",
    "Locked": "LOCKED",
    "Equip": "EQUiP",
    "Unequip": "UNEQUiP",
    "AddTimePerk": "TiME BONUS",
    "AddTimePerkDescription1": "Add time to the clock in Timed Mode!",
    "AddTimePerkDescription2": "Start Time Increase +4 seconds",
    "AddTimePerkDescription3": "Start Time Increase +6 seconds",
    "AddTimePerkDescription4": "Start Time Increase +8 seconds",
    "AddTimePerkDescription5": "Start Time Increase +10 seconds",
    "Barriers": "BLOB BARRiERS",
    "CoconutBombs": "COCONUT BOMBS",
    "ClockMagnets": "CLOCK MAGNETS",
    "CoinMagnets": "COiN MAGNETS",
    "Nukes": "PANiC BUTTONS",
    "SkullSmashers": "SKULL SMASHERS",
    "FruitSmashers": "FRUiT HAMMERS",
    "CherryBonus": "CHERRY BONUS!",
    "GenericMenuText1": "Me and campfires? We don't mix, let's just put it that way.",
    "GenericMenuText2": "I've always had this phobia of sticks and fires, I dunno why.",
    "GenericMenuText3": "These blobs are a knightmare. (Only cool people will get that.)",
    "GenericMenuText4": "You know what they say! \"When life gives you lemons, chuck them at a blob.\"",
    "GenericMenuText5": "Surprisingly, I'm a big fan of hot chocolate.",
    "GenericMenuText6": "You wouldn't like me when I'm melted. Well, I wouldn't like it at least.",
    "GenericMenuText7": "One of my favorite games is Wind-up Knight. You should check it out.",
    "GenericMenuText8": "I had this horrible dream I was a donut.",
    "GenericMenuText9": "My name is Marsh Mal. Nice to meet ya.",
    "GenericMenuText10": "Help me keep these blobs at bay!",
    "GenericMenuText11": "Nobody knows exactly why, but marshmallows are fans of high places.",
    "GenericMenuText12": "Where do I get all this fruit? A marshmallow never tells.",
    "GenericMenuText13": "There are many conspiracy theories on where these blobs came from.",
    "GenericMenuText14": "The gooey part of me wonders if these are alien blobs.",
    "GenericMenuText15": "The blobs are definitely aliens. Maybe.",
    "GenericMenuText16": "Some say the blobs are government experimentation gone awry.",
    "GenericMenuText17": "Some say the blobs are nature's revenge.",
    "GenericMenuText18": "Some (crazy people) say the blobs were destined to absorb us all.",
    "GenericMenuText19": "Some say the blobs are the next step in evolution.",
    "GenericMenuText20": "Some say that what some say is a lotta horseradish.",
    "GenericMenuText21": "Some say the blobs are the beginning of the end. Harsh!",
    "GenericMenuText22": "Will we ever truly know what caused the blobs?",
    "GenericMenuText23": "I need a catchphrase but nothing comes to mind. Graham crackers! One of these days, I'll think of one.",
    "GenericMenuText24": "I always wanted to be an astronaut but then I realized space freaks me out.",
    "GenericMenuText25": "Marshmallows are my peeps.",
    "GenericMenuText26": "Us marshmallows, we gotta stick together. In fact, we can't help it.",
    "GenericMenuText27": "I have a sister. Her name is Marsh Mel.",
    "GenericMenuText28": "All the cool kids play Wind-up Knight.",
    "GenericMenuText29": "I <3 Wind-up Knight.",
    "GenericMenuText30": "Don't throw fruit at people. Throw fruit at blobs.",
    "GenericMenuText31": "No fruits were harmed in the making of this game.",
    "GenericMenuText32": "Blobs were totally harmed in the making of this game. They had it coming!",
    "GenericMenuText33": "Tear down the (fourth) wall!",
    "GenericMenuText34": "My favorite film: What About Blob?",
    "GenericMenuText35": "The Blobfather Part 2 is one of the most critically acclaimed films ever made.",
    "GenericMenuText36": "Blobs' absolute favorite food are marshmallows. Sucks to be me.",
    "GenericMenuText37": "The internet?! What's that?",
    "GenericMenuText38": "What?! You've never heard of blue apples? What other color would they be?",
    "GenericMenuText39": "I don't know what you're sayin'. ALL apples are blue.",
    "GenericMenuText40": "Listen. I dunno where you're from, but the apples are blue around here.",
    "GenericMenuText41": "You ever find that you're repeating yourself?",
    "InGameChatterRising1": "Graham crackers! The stack is rising!",
    "InGameChatterRising2": "Incoming blobs!",
    "InGameChatterRising3": "Here they come!",
    "InGameChatterRising4": "Blobs are on the move!",
    "InGameChatter1": "Things are gettin' outta hand.",
    "InGameChatter2": "How do I get myself into these situations?",
    "InGameChatter3": "Where DOES this fruit come from?",
    "InGameChatter4": "These blobs mean business!",
    "InGameChatter5": "My supply of fruit is unlimited, FYI.",
    "InGameChatter6": "I should stay away from tower-like objects!",
    "InGameChatter7": "Shoulda known better than to come up here.",
    "InGameChatter8": "Keep them blobs away from me!",
    "InGameChatter9": "Good thing I'm not afraid of heights!",
    "InGameChatter10": "Hot chocolate!",
    "InGameChatter11": "Have you seen a ladder around here?",
    "InGameChatter12": "Graham crackers!",
    "InGameTimeChatter1": "That time counter is dropping like it's hot. Wait, what?",
    "ShapeBonusBubble": "Tetromino!",
    "SequenceBonusBubble": "Color Match!",
    "Owned": "OWNED!",
    "Unavailable": "UNAVAiLABLE",
    "PopUpNotificationAccept": "GOT iT!",
    "Welcome1": "Let's get crackin'!",
    "Welcome2": "Ready for s'more?",
    "Welcome3": "It's fruit tossin' time.",
    "Welcome4": "Hey, welcome back!",
    "Welcome5": "Welcome back!",
    "Welcome6": "Good to see you again!",
    "Welcome7": "Let's do this!",
    "Welcome8": "Howdy, pardner.",
    "Welcome9": "Time for some blob popping action!",
    "Welcome10": "Marshmallow Kombat!",
    "Welcome11": "Let's get started!",
    "Welcome12": "Get ready to pop some blobs!",
    "Welcome13": "It's time!",
    "MissionMenuText1": "Do all 3 to claim your prize!",
    "MissionMenuText2": "Do all these things to earn something good.",
    "MissionMenuText3": "Here's what ya gotta do to earn a reward.",
    "MissionCompleteMenuText1": "Hot chocolate! Mission accomplished!",
    "MissionCompleteMenuText2": "I love it when a plan comes together!",
    "MissionCompleteMenuText3": "Don't stop 'til you get enough!",
    "ComingSoonDescription": "New stages will be uncovered soon! Stay tuned!",
    "GetReward": "GET REWARD!",
    "Completed": "COMPLETED!",
    "IslandDescription": "Besides the shark infested waters and an active volcano, this island is a paradise!",
    "ArcticDescription": "The pipeline is cracked with ooze leaking everywhere... but, check it out, whales!",
    "CandylandDescription": "A place of cotton candy clouds, mountainous cakes and a river of molten chocolate. No swimming allowed!",
    "ForestDescription": "A crystal clear lake and a cabin in the woods. This set up sounds familiar... Uh oh!",
    "SwampDescription": "A creepy mansion, ghostly graveyard and gnarly trees make this a spooky retreat. Retreat!",
    "DesertDescription": "This painted desert is apparently a final destination for tumbleweeds, trains and... meteorites!",
    "WukAreaDescription": "Revisit the world of Wind-Up Knight!",
    "WukAreaDescriptionLocked": "PASSHOLDER EXCLUSiVE",
    "MoonDescription": "Did robots really land on the moon in 1969?",
    "MoonDescriptionLocked": "PASSHOLDER EXCLUSiVE",
    "Exclusive": "EXCLUSiVE",
    "EliteClubExclusive": "PASSHOLDER EXCLUSiVE",
    "OptionsMenuText1": "So many options! Where to start?",
    "OptionsMenuText2": "Step right up! Make yer selections now!",
    "OptionsMenuText3": "Choose wisely!",
    "GameOverMenuHighScore1": "You beat the high score!",
    "GameOverMenuHighScore2": "Wow, you're getting better at this!",
    "GameOverMenuHighScore3": "Impressive score!",
    "GameOverMenuHighScore4": "Goooooooaaaaaal!",
    "EasyGamesPlayedMissionFormat": "Play {0} games of NORMAL Mode",
    "MissionNotificationFormat": "MiSSiON {0} COMPLETED!",
    "BombsUsedMissionFormat": "Use a total of {0} COCONUT BOMBS",
    "BombsUsedInModeMissionFormat": "Use a total of {0} COCONUT BOMBS in {2}",
    "ShapeBonusMissionFormat": "Get a total of {0} TETROMINOS",
    "PopNumberOfBlobsMissionFormat": "Pop {0} {1} BLOBS in {2}",
    "PopNumberOfBlobsSingleMissionFormat": "Pop {0} {1} BLOBS in a single game of {2}",
    "PopBlobsMissionFormat": "Pop {0} total BLOBS in {2}",
    "NumberOfSkullsMissionFormat": "Collect {0} SKULLS in a single game of Skull Mode",
    "HighScoreMissionFormat": "{2}: Get a SCORE of {0} in a single game",
    "ReachLevelMissionFormat": "Reach WAVE {0} in {2}",
    "NumberOfClocksMissionFormat": "Collect {0} CLOCKS in a single game of Timed Mode",
    "CumulativeScoreMissionFormat": "Achieve a cumulative {2} SCORE of {0}",
    "CumulativeSkullsMissionFormat": "Smash a cumulative total of {0} SKULLS",
    "NumberOfCoinsMissionFormat": "{2}: Collect {0} COINS from blobs in a single game",
    "NumberOfRainbowFruitMissionFormat": "Drop a total of {0} RAINBOW FRUIT",
    "NumberOfNukesMissionFormat": "Use a total of {0} PANIC BUTTONS",
    "NumberOfFruitSmashersMissionFormat": "Use the FRUIT HAMMER a total of {0} times",
    "NumberOfBarriersMissionFormat": "Use a total of {0} BARRIERS",
    "NumberOfClockMagnetsMissionFormat": "Use CLOCK MAGNETS a total of {0} times",
    "NumberOfSkullSmashersMissionFormat": "Use the SKULL SMASHER a total of {0} times",
    "NumberTNTMissionsFormat": "Blow up a total of {0} TNT blobs",
    "NumberDiamondsMissionFormat": "Collect a total of {0} DIAMONDS from blobs",
    "NumberGoldBricksMissionFormat": "Collect a total of {0} GOLD BARS from blobs",
    "NumberMushroomBlobsMissionFormat": "Blow up a total of {0} MUSHROOMS",
    "Missions": "MiSSiONS",
    "ScreenshotSaying1": "Hot chocolate!",
    "ScreenshotSaying2": "Check it out!",
    "ScreenshotSaying3": "Heads up!",
    "FacebookPost1": "I got a score of {0} on {1} in \"Rise of the Blobs!\"",
    "ScreenshotPost1": "I got a great score on {0}!",
    "ScrollingText1": "You're playing Rise of the Blobs by Robot Invader.",
    "ScrollingText2": "Check out www.robotinvader.com for the latest news.",
    "ScrollingText3": "Follow us on twitter: @robotinvader",
    "ScrollingText4": "Check out Wind-up Knight for hardcore platforming action!",
    "ScrollingText5": "This message brought to you by Robot Invader.",
    "MissionStatOrange": "ORANGE",
    "MissionStatBlue": "BLUE",
    "MissionStatGreen": "GREEN",
    "MissionStatRed": "RED",
    "MissionStatYellow": "YELLOW",
    "MissionStatPink": "PINK",
    "MissionStatPurple": "PURPLE",
    "MissionStatMoon": "MOON",
    "MissionStatTurquoise": "TURQUOISE",
    "MissionStatBrown": "BROWN",
    "NoRecentScore": "No Score This Week",
    "LeaderboardCountdown": "Leaderboard resets in {0}, {1}, {2}",
    "DaySingular": "{0} day",
    "DayPlural": "{0} days",
    "HourSingular": "{0} hour",
    "HourPlural": "{0} hours",
    "MinuteSingular": "{0} minute",
    "MinutePlural": "{0} minutes",
    "SecondSingular": "{0} second",
    "SecondPlural": "{0} seconds",
    "Invite": "iNViTE",
    "FacebookInviteTitle": "Come play Rise of the Blobs!",
    "FacebookInviteMessage": "Get Rise of the Blobs for FREE and let's compare scores!",
    "FacebookPostScore": "I got {0} points in Rise of the Blobs!",
    "FacebookPostDescription": "I just scored {0} in {1} playing Rise of the Blobs! Hot chocolate!",
    "FacebookPostLink": "http://goo.gl/BE4Qc",
    "FacebookPostImage": "http://s3.amazonaws.com/com.robotinvader.fooding/fbPostRiseLogo.png",
    "FacebookPostCaption": "Rise of the Blobs",
    "FacebookPostSuccessMessage": "Your score was posted!",
    "FacebookPostSuccessMessageAcceptButton": "HOORAY!",
    "TwitterScoreTweet": "I just scored {0} in {1} playing Rise of the Blobs! Hot chocolate! #riseoftheblobs",
    "TopScoreTitle": "Your Top Score",
    "VS": "VS",
    "LastWeek": "Last Week",
    "TwoWeeksAgo": "2 Weeks Ago",
    "ThreeWeeksAgo": "3 Weeks Ago",
    "FourWeeksAgo": "4 Weeks Ago",
    "TopScoreButton": "OK",
    "Website": "WEBSiTE",
    "AnonymousLocalUserName": "Me",
    "DividerText": "FRiENDS",
    "ThisWeek": "This Week",
    "MalwearHeadphones": "HEADPHONES",
    "MalwearHeadphonesDescription": "Beats by Mal.",
    "MalwearHeadphonesText": "These were kinda pricey...",
    "MalwearNerdGlasses": "SMARTYPANTS",
    "MalwearNerdGlassesDescription": "Eyewear for the distinguished marshmallow.",
    "MalwearNerdGlassesText": "I don't even wear pants!",
    "MarshMal": "MARSH MAL",
    "WeeklyRecord": "HiGH SCORE",
    "Translator": "asrec",
    "CreditsTranslation": "Translation",
    "JapaneseTranslator": "8-4, Ltd.",
    "CreditsJapanese": "Japanese Translation",
    "TransactionsRestoredMessage": "Purchases Restored!",
    "TransactionsRestoredMessageAcceptButton": "OK!",
    "TutorialGameSetUpInventory": "CHECK OUT YOUR POWER-UP iNVENTORY HERE!",
    "GamesPlayedMissionFormat": "Play {0} games of {2}",
    "GenkiMine": "Genki Mine",
    "VincentRenaud": "Vincent Renaud",
    "OnSale": "SALE!",
    "FruitHUD": "FRUiT: {0}",
    "TutorialQuickplayMode1": "YOU ONLY HAVE 100 FRUiT! USE THEM WiSELY!",
    "TutorialQuickplayMode2": "COLLECT STARS TO GET BiG POiNTS!",
    "QuickplayBonusText": "SUPERSTAR!",
    "QuickplayModeLow": "Star Mode",
    "Quickplay": "STAR",
    "QuickplayMode": "STAR MODE",
    "AchievementBeatQuickplay": "WELCOME TO THE JUNGLE",
    "AchievementBeatQuickplayDescription": "Complete Star Mode!",
    "BeatQuickplayMode": "Completed Games",
    "QuickplayGamesPlayed": "Games Played",
    "HighScoreQuickplay": "Highest Score Ever!",
    "MalModeSelectDescriptionQuickplay": "How many Stars can you collect with only 100 fruit?",
    "QuickplayModeStat": "Star",
    "NextFreeGiftIn": "Next Reward In: {0}, {1}",
    "AddBonusCountdownPerkDescription1": "Increases the starting value of Stars!",
    "AddBonusCountdownPerkDescription2": "Starting value +2",
    "AddBonusCountdownPerkDescription3": "Starting value +3",
    "AddBonusCountdownPerkDescription4": "Starting value +4",
    "AddBonusCountdownPerkDescription5": "Starting value +5",
    "CountdownStarBonus": "STAR BOOSTER",
    "LastStarsCollected": "Stars Collected",
    "TotalStarsCollected": "Total Stars Collected",
    "HighStarsCollected": "High Stars Collected",
    "LastFruitLeft": "Remaining Fruit",
    "AchievementTristar": "ORiON",
    "AchievementTristarDescription": "Collect {0} Stars in a Single Game of Star Mode",
    "FruitToGo": "{0} TO GO!",
    "LastFruit": "LAST FRUiT!",
    "TipsStarBooster": "The STAR BOOSTER creates stars with higher initial values in Star Mode. Reach for the stars!",
    "DailyReward": "DAiLY REWARD",
    "AchievementStarCatcher": "STAR CATCHER",
    "AchievementStarCatcherFormat": "Play {0} Star Mode games",
    "FungusModeLow": "Mushroom Mode",
    "Fungus": "MUSHROOM",
    "FungusMode": "MUSHROOM MODE",
    "FungusModeStat": "Mushroom",
    "MushroomPopperUpgradeDescription1": "Helps clear a path in Mushroom Mode!",
    "MushroomPopperUpgradeDescription2": "Pop 4 Mushrooms, Decrease Cooldown 10%",
    "MushroomPopperUpgradeDescription3": "Pop 7 Mushrooms, Decrease Cooldown 15%",
    "MushroomPopperUpgradeDescription4": "Pop 9 Mushrooms, Decrease Cooldown 25%",
    "MushroomPopperUpgradeDescription5": "Pop 12 Mushrooms, Decrease Cooldown 40%",
    "MushroomPoppers": "MUSHROOM SLiCERS",
    "MushroomPopper": "MUSHROOM SLiCER",
    "MushroomPoppersInventoryFormat": "{0} MUSHROOM SLiCERS",
    "AchievementBeatFungusMode": "BAD MEDiCiNE",
    "AchievemenBeatFungusModeDescription": "Complete Mushroom Mode",
    "AchievementPlayNumberGamesFungus": "TRUFFLE SHUFFLE",
    "AchievementPlayNumberGamesFungusDescription": "Play {0} games of Mushroom Mode",
    "AchievementTotalNumberMushrooms": "FUNGiCiDE",
    "AchievementTotalNumberMushroomsDescription": "Cream {0} Mushrooms in Mushroom Mode",
    "LastMushrooms": "Mushrooms Creamed",
    "HighMushrooms": "High Mushrooms Creamed",
    "MushroomsPoppedInMushroomMode": "Total Creamed Mushrooms",
    "HighScoreFungus": "Highest Score Ever!",
    "FungusGamesPlayed": "Games Played",
    "BeatFungusMode": "Completed Games",
    "ReadyScreen": "GET READY!",
    "MalModeSelectDescriptionFungus": "Blobs get sleepy late at night. Mushrooms everywhere!",
    "TutorialFungusMode1": "FRUiT FiLLED BLOBS AUTOMATiCALLY POP iN THiS MODE!",
    "TutorialFungusMode2": "CREAM MUSHROOMS FOR MASSiVE POiNTS!",
    "CupcakeModeLow": "Cupcake Mode",
    "Cupcake": "CUPCAKE",
    "CupcakeMode": "CUPCAKE MODE",
    "CupcakeModeStat": "Cupcake",
    "AchievementBeatCupcakeMode": "SWEET DREAMS (ARE MADE OF THiS)",
    "AchievementBeatCupcakeModeDescription": "Complete Cupcake Mode",
    "AchievementPlayNumberGamesCupcake": "CUPCAKES ANONYMOUS",
    "AchievementPlayNumberGamesCupcakeDescription": "Play {0} games of Cupcake Mode",
    "LastCupcakes": "Cupcakes Eaten",
    "HighCupcakes": "High Cupcakes Eaten",
    "TotalCupcakes": "Total Cupcakes Eaten",
    "HighScoreCupcake": "Highest Score Ever!",
    "CupcakeGamesPlayed": "Games Played",
    "BeatCupcakeMode": "Completed Games",
    "MalModeSelectDescriptionCupcake": "As easy at it gets. Cupcakes will be eaten!",
    "TutorialCupcakeMode1": "GET CUPCAKES FOR BIG STOMACH!",
    "PrivacyPolicy": "PRiVACY POLiCY",
    "PassholderExclusiveMode": "Become a Passholder to get this Exclusive Mode!",
    "SkipMissionDescriptionFormat": "Skip this mission for {0} coins?",
    "CupcakeModeStoreDescription": "This delectable mode is perfect for those seeking LESS of a challenge and MORE chocolatey goodness in their game. Fruit-filled blobs pop automatically!",
    "Premuim": "PREMiUM",
    "TipsCupcakeMode": "Collect cupcakes in this low pressure, high calorie Premium Mode!",
    "PercentOff": "{0}% OFF!",
    "SaleDescription": "Check out what's on SALE right now!",
    "Auto": "AUTO",
    "UnlockMushroomPopperTask": "Play {0} Game of Mushroom Mode",
    "Share": "SHARE",
    "Post": "POST",
    "Tweet": "TWEET",
    "MalwearLuckyHat": "LUCKY HAT",
    "MalwearLuckyHatDescription": "Classic look sure to make others green with envy.",
    "MalwearLuckyHatText": "Who stole my lucky charms?",
    "MalwearBunny": "BUNNY EARS",
    "MalwearBunnyDescription": "Hip hop attire!",
    "MalwearBunnyText": "Suddenly, I have this craving for carrots...",
    "Autopop": "AUTO-POP!",
    "HighestLevelNormal": "Highest Wave",
    "HighestLevelTimed": "Highest Wave",
    "HighestLevelSkull": "Highest Wave",
    "HighestLevelExpert": "Highest Wave",
    "HighestLevelCupcake": "Highest Wave",
    "HighestLevelFungus": "Highest Wave",
    "MalwearNewYears": "PARTY HAT",
    "MalwearNewYearsDescription": "Who likes to party?!",
    "MalwearNewYearsText": "I likes to party!",
    "MalwearLovestruck": "LOVESTRUCK",
    "MalwearLovestruckDescription": "Love is in the air.",
    "MalwearLovestruckText": "sigh...",
    "MalwearPumpkin": "JACK O LANTERN",
    "MalwearPumpkinDescription": "Pumpkin head.",
    "MalwearPumpkinText": "Trick or treat!",
    "MalwearTurkey": "TURKEY",
    "MalwearTurkeyDescription": "Gobble gobble!",
    "MalwearTurkeyText": "Don't give me no jive, turkey!",
    "MalwearReindeer": "REiNDEER",
    "MalwearReindeerDescription": "Perfect for guiding sleighs at night.",
    "MalwearReindeerText": "My nose itches!",
    "MalwearFreedomHat": "FREEDOM HAT",
    "MalwearFreedomHatDescription": "Only you can prevent forest fires... ?!",
    "MalwearFreedomHatText": "Would you like fries with that?",
    "Home": "HOME",
    "TipLoginBenefit": "LOGIN to save your progress across devices! You can also compare your scores to your friends!",
    "TipMalwearHoliday": "Now Available! Exclusive NEW Malwear for Passholders!",
    "TipMalwearNew": "New MALWEAR is available! Now's a great time to customize your marshmallow!",
    "GamePlayTip39": "You can tap me to cycle through my wardrobe!",
    "GamePlayTip40": "Some Modes are Auto-pop. I dunno what that means but I'm sure you got it figured out.",
    "TipSale": "Don't miss out! This SALE is for a limited time!",
    "MalwearAngel": "ANGEL HELM",
    "MalwearAngelDescription": "A heavenly outfit.",
    "MalwearAngelText": "FYI, Wind-up Knight has an Angel Helm too!",
    "TipLeaderboard": "Check out the LEADERBOARDS to compare scores with your friends!",
    "DesertPackDescription": "Unlock the DESERT Stage\\n + Bonus of 7,500 coins!",
    "DesertPack": "GOLD RUSH!",
    "DesertPackCoins": "\\n +7,500 coins",
    "DesertPackWithCoins": "GOLD RUSH! \\n{0} COiNS",
    "LimitedOffer": "LiMiTED OFFER",
    "LimitedOfferTimeLeftHours": "{0}:{1}:{2}",
    "DaySingularBold": "{0} DAY",
    "DayPluralBold": "{0} DAYS",
    "Support": "SUPPORT",
    "RewardScreenDescriptionAlt": "POP THE BLOB TO CLAiM YOUR REWARD!",
    "Rank50": "RANK 50",
    "AchievementRank50Format": "Achieve Player Rank {0}",
    "FreezeDropDescription": "Pause fruit in the air! Swipe down to make it fall!",
    "FreezeDropSku": "{0} FREEZE DROPS",
    "PurchaseFreezeDropsDialog": "You got {0} Freeze Drops!",
    "TipFreezeDrop": "The FREEZE DROP allows you to pause fruit before it falls! Swipe down when you're ready to drop it!",
    "TutorialFreezeDrop1": "TRY OUT THE FREEZE DROP!",
    "TutorialFreezeDrop2": "SWiPE DOWN WHEN YOU'RE READY TO DROP THE FRUiT!",
    "TutorialBombsExplanation": "COCONUT BOMBS: BLOW UP ALL BLOBS OF THE SAME COLOR!",
    "TutorialEndCondition": "DON'T LET THE BLOBS REACH THE TOP!",
    "NeedMoreFreezeDrops": "You're out of Freeze Drops! Buy {0} more?",
    "NeedMoreFreezeDropsAccept": "YES",
    "NeedMoreFreezeDropsReject": "NO",

    "CooldownTutorial": "Bombs are hot! Wait a few turns before you can use them again",
    "DoubleCoins": "DOUBLE COINS"
}
